import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const StatusContext = createContext([{ disabled: false }, () => {}]);

const StatusProvider = (props) => {
  const [status, setStatus] = useState({ disabled: props?.disabled || false });

  // Memoize the context value to prevent unnecessary rerenders
  const contextValue = useMemo(() => [status, setStatus], [status]);

  return <StatusContext.Provider value={contextValue}>{props.children}</StatusContext.Provider>;
};

StatusProvider.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export { StatusContext, StatusProvider };
